import { DashboardContent } from "../models/DashboardContent";
import { ProductType } from "../models/ProductType";
import { Slider } from "../models/Slider";

export class MobileDashboardResponse {
    public sliderImages: Array<Slider>;
    public productTypes: Array<ProductType>;
    public dashboardContents: Array<DashboardContent>;
}
